import React from 'react';
import Navbar from './global-components/navbar-v3';
import PageHeader from './global-components/page-header';
import ForgotPassword from './section-components/forgot-password';
import Footer from './global-components/footer';

const SignUpPage = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Forgot Password"  />
        <ForgotPassword />
        <Footer />
    </div>
}

export default SignUpPage

